<template>
    <div>
        <transition-group name="slide-fade">
            <div 
            key="empty"
            class="text-center"
            v-if="!id">
                Une key est nécéssaire pour afficher le formulaire.
            </div>

            <div 
            key="loader"
            class="text-center"
            v-if="id && loading">
                <loader />
            </div>

            <component 
            ref="form"
            key="form"
            @submit="submit"
            v-else-if="id && !loading"
            :is="layoutFile" />

        </transition-group>
    </div>
</template>

<script>

    import {mapState, mapGetters} from 'vuex'

    export default {

        props: {
            id: {
                type: String,
                default: '',
            }
        },

        data() {
            
            return {
                loading: false
            }
        },

        computed: {

            ...mapState({
                store: state => state.form,
                form: state => state.form.form,
                stop: state => state.form.stop,
            }),

            ...mapGetters('form', [
                'answers'
            ]),
            
            layoutFile() {

                var tpl = 'default/Layout'
                var custom = false

                var layouts = require.context('@components/forms/layouts', true);

                layouts.keys().forEach(file => {
                    if(file.includes(this.form.layout))
                    {
                        tpl = this.form.layout+'/Layout'
                    }
                })

                // Is there a custom layout ?
                try {
                    let file = require('@components/forms/'+this.id+'/Layout');
                    custom = true
                } catch (e) {}

                if(tpl) {
                    return () => custom 
                    ? import(`@components/forms/${this.id}/Layout.vue`)
                    : import(`@components/forms/layouts/${tpl}.vue`);
                }

            }

        },

        methods: {
            submit(answers) {
                this.$emit('submit', {
                    answers: this.store.answers,
                    readableAnswers: this.answers
                })
            }
        },

        mounted() {

            this.loading = true

            if(this.id)
            {
                this.$store
                .dispatch('form/initForm', this.id)
                .then(response => { 
                    console.log('hello')
                    this.loading = false 
                })
            }

            

        }
        
    }
</script>